export const DEFAULT_PAGINATION = [25, 50, 75, 100]
